webpackJsonp([212865592729468],{

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'blog', style: { margin: '0 auto', maxWidth: '70ch' } },
	      _react2.default.createElement(
	        _Link2.default,
	        { href: '/blog' },
	        'Latest \u2192'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Presenting your requests to our Father in Heaven'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'author' },
	        'by Jon Shulver, 20 March 2020'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Paul says in Philippians 4:6 \u201CDo not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving present your requests to God.\u201D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Let\u2019s be honest, most of us have felt some anxiety over the last week. It\u2019s hard not to. But God wants to take our anxiety from us. He wants us, as best we can, to hand it over to him; to exchange it for his peace (Philippians 4:7). Paul says that a vital means of doing that is to pray to God: to present our requests to him. To exchange anxiety for peace, as we pray.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'But how should we pray? What can we ask for? Well, Paul says we can simply \u201Cpresent our requests to God\u201D.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        ' Our requests might currently be something like this:'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { paddingLeft: '2em' } },
	        '\u201CPlease God, in your mercy, help the spread of the virus to soon stop.\u201D',
	        _react2.default.createElement('br', null),
	        '\u201CPlease God, give wisdom to our government and the rulers you have placed over us, as they have to make difficult decisions.\u201D',
	        _react2.default.createElement('br', null),
	        '\u201CPlease God, for those that are needy and vulnerable: shield them from infection and help us love them as we love ourselves.\u201D',
	        _react2.default.createElement('br', null),
	        '"Please God, for those who are working to provide medical care and essential services: grant them protection and strength.\u201D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Let\u2019s also remember the prayer that Jesus taught his disciples to pray; his model prayer of handing our needs, our sin and our anxiety over to God.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In Matthew 6, Jesus said:'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { paddingLeft: '2em' } },
	        '\u201CThis, then, is how you should pray:',
	        _react2.default.createElement('br', null),
	        ' "Our Father in heaven, hallowed be your name,',
	        _react2.default.createElement('br', null),
	        '\xA0your kingdom come,',
	        _react2.default.createElement('br', null),
	        'your will be done,',
	        _react2.default.createElement('br', null),
	        '\xA0\xA0\xA0\xA0on earth as it is in heaven.',
	        _react2.default.createElement('br', null),
	        '\xA0Give us today our daily bread. ',
	        _react2.default.createElement('br', null),
	        'And forgive us our debts,',
	        _react2.default.createElement('br', null),
	        '\xA0\xA0\xA0\xA0as we also have forgiven our debtors. \xA0',
	        _react2.default.createElement('br', null),
	        'And lead us not into temptation,',
	        _react2.default.createElement('br', null),
	        '\xA0\xA0\xA0but deliver us from the evil one."'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Down the centuries, countless millions have used these words as a basis for prayer and a help in bringing their requests to God. Can I encourage us to do the same? To pray to \u201COur Father in heaven\u201D. There is much comfort in those opening words. He is Our Father. Because of the death and resurrection of Jesus, we can know and speak to God as Our Father. Not a force or power, not an impersonal God, not a distant relative, but Our Father. A loving father who cares for his children, but also a father who is in heaven. He\u2019s not limited in power and knowledge and love like earthly fathers. But he\u2019s Our Father in heaven, whose power and knowledge and love is complete.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our Father in Heaven. That\u2019s who is waiting to hear our requests.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Jon'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you want to listen to more of what the Bible says about anxiety and worry then you can listen to a talk given at a Cornerstone gathering via the following link: \xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://talks.cornerstonechurchportsmouth.org/sermons/?wpfc_sermon_series=battles-christians-face' },
	          'Battles Christians Face'
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlogPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-20-march-js-50c958aa9098c96d012a.js